/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Whether this carrier is in the registry at all, and where it sits commercially.
 * @export
 * @interface CarrierRegistryEntry
 */
export interface CarrierRegistryEntry {
  /**
   *
   * @type {string}
   * @memberof CarrierRegistryEntry
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierRegistryEntry
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CarrierRegistryEntry
   */
  crmStage: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierRegistryEntry
   */
  crmStageChangedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierRegistryEntry
   */
  disqualifiedReason?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierRegistryEntry
   */
  linearIssueKey?: string | null;
}

/**
 * Check if a given object implements the CarrierRegistryEntry interface.
 */
export function instanceOfCarrierRegistryEntry(
  value: object,
): value is CarrierRegistryEntry {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("crmStage" in value) || value["crmStage"] === undefined) return false;
  return true;
}

export function CarrierRegistryEntryFromJSON(json: any): CarrierRegistryEntry {
  return CarrierRegistryEntryFromJSONTyped(json, false);
}

export function CarrierRegistryEntryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierRegistryEntry {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    name: json["name"],
    crmStage: json["crmStage"],
    crmStageChangedAt:
      json["crmStageChangedAt"] == null ? undefined : json["crmStageChangedAt"],
    disqualifiedReason:
      json["disqualifiedReason"] == null
        ? undefined
        : json["disqualifiedReason"],
    linearIssueKey:
      json["linearIssueKey"] == null ? undefined : json["linearIssueKey"],
  };
}

export function CarrierRegistryEntryToJSON(json: any): CarrierRegistryEntry {
  return CarrierRegistryEntryToJSONTyped(json, false);
}

export function CarrierRegistryEntryToJSONTyped(
  value?: CarrierRegistryEntry | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    name: value["name"],
    crmStage: value["crmStage"],
    crmStageChangedAt: value["crmStageChangedAt"],
    disqualifiedReason: value["disqualifiedReason"],
    linearIssueKey: value["linearIssueKey"],
  };
}
